<script setup lang="ts">
import {ref, watch} from 'vue';
import {ElRadioButton, ElRadioGroup} from 'element-plus';
import {localStorageGetJson, localStorageSetJson} from '@/base/utils.js';
import DashboardUploadPanel from '@/views/admin/DashboardUploadPanel.vue';
import DashboardTargetsSection from '@/views/admin/DashboardTargetsSection.vue';
import InitiatiefSection from '@/views/admin/InitiatiefSection.vue';
import FteTargetSection from '@/views/admin/FteTargetSection.vue';
import FinancieleRegelSection from '@/views/admin/FinancieleRegelSection.vue';

const STORAGE_SECTIE_ID: string = 'dashboard:data:sectie';
const SECTIES: string[]         = ['Upload', 'KPI targets', 'Initiatieven', 'FTE targets', 'Financien'];

const sectie = ref<string>(SECTIES.includes(localStorageGetJson(STORAGE_SECTIE_ID)) ? localStorageGetJson(STORAGE_SECTIE_ID) : SECTIES[0]);

watch(sectie, (s: string) => localStorageSetJson(STORAGE_SECTIE_ID, s));
</script>

<template>
    <div class="flex flex-col flex-1 mx-28 my-5 gap-4">
        <el-radio-group v-model="sectie">
            <el-radio-button v-for="s in SECTIES" :key="s" :value="s">{{ s }}</el-radio-button>
        </el-radio-group>

        <DashboardUploadPanel v-if="sectie === 'Upload'"/>
        <DashboardTargetsSection v-if="sectie === 'KPI targets'"/>
        <InitiatiefSection v-if="sectie === 'Initiatieven'"/>
        <FteTargetSection v-if="sectie === 'FTE targets'"/>
        <FinancieleRegelSection v-if="sectie === 'Financien'"/>
    </div>
</template>
